import * as ACTION_TYPES from './actiontypes';

export const initRequest = () => ({
  type: ACTION_TYPES.INIT_REQUEST
});

export const initSuccess = response => ({
  type: ACTION_TYPES.INIT_SUCCESS,
  payload: { ...response }
});

export const initFailure = error => ({
  type: ACTION_TYPES.INIT_FAILURE,
  error
});

export const showLoading = statusMessage => ({
  type: ACTION_TYPES.SHOW_LOADING,
  payload: {
    statusMessage
  }
});

export const hideLoading = () => ({
  type: ACTION_TYPES.HIDE_LOADING
});
